import { render, staticRenderFns } from "./App.vue?vue&type=template&id=64d086cc&scoped=true&"
import script from "./app.ts?vue&type=script&lang=ts&"
export * from "./app.ts?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=64d086cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d086cc",
  null
  
)

export default component.exports